export type DemoIntent = 'pricing' | null;

export const getDemoIntent = (search: string): DemoIntent => (
  new URLSearchParams(search).get('intent') === 'pricing' ? 'pricing' : null
);

export const withDemoIntent = <T extends Record<string, unknown>>(
  fields: T,
  intent: DemoIntent,
): T & { intent?: 'pricing' } => (
  intent ? { ...fields, intent } : fields
);
